fx.ns("shared.renderers", class PhotoRenderer extends fx.Component{
    
	constructor(data)
	{
		super(data);
	}

	onReady()
	{
		super.onReady();

        if (fx.browser.isDesktop)
        {
            this.on("mouseover", this.onMouseOver);
            this.on("mouseout", this.onMouseOut);
        }

		if (this.deleteIcon)
			this.on("click", this.onRemove, this.deleteIcon);

		this.attr("data-id", this.data.id);
	}

    hide()
    {
        super.hide();
    }

	create()
	{
		this.image = new fx.components.Image({className : this.data.isHeic && !this.data.uploaded ? "uploading" : "draggable", data : this.data.thumb});
		this.image.attr("data-class", "Photo");
		this.image.attr("data-id", this.data.id);
        this.image.attr("data-behaviour","add-component");
		// tmp
		this.image.attr("data-width", this.data.width);
		this.image.attr("data-height", this.data.height);
        //this.image.toolTip = fx.text("Déplacer et déposez<br>ou Cliquez  pour ajouter<br>")

		this.addChild(this.image);

		this.usedIcon = new fx.components.Image({data : fx.assets.used, className : "usedicon", tooltip : fx.text("Photo utilisée")});
		this.usedIcon.visibleAtStart = false;
		
		this.addChild(this.usedIcon, {top:0, left:0, width:30, height:30});

		this.deleteIcon = new fx.components.Image({data : fx.assets.deleteIcon, className : "delete", tooltip : fx.text("Supprimer")});
		this.deleteIcon.visibleAtStart = false;

		if(this.data.isHeic && !this.data.uploaded)
		{
			this.progress = new fx.components.Box("progress");
			this.addChild( this.progress, {width : 0, height:5, bottom : 0 , left : 0});

			this.waiting = new fx.components.Image({data : fx.assets.loader, className : "extacting"});
			this.addChild(this.waiting, {width : 30, height : 30, left : "center", top : "center"});

			this.toolTip = fx.text("Veuillez attendre la fin du transfer<br>pour pouvoir utiliser cette photo.");
		}
		
		this.addChild(this.deleteIcon, {bottom:0, right:0, width:30, height:30});
	}

	/*render()
	{
		let html =  '<img class="draggable" data-class="Photo" src="' + this.data.thumb + '" data-id="' + this.data.id + '" data-width="' + this.data.width + '" data-height="' + this.data.height + '" >'
					+ '<div class="usedicon" title="Cette photo est utilisée dans votre ouvrage">' + fx.assets.used.render() + '</div>' 
					+'<div class="delete" title="Supprimer">' + fx.assets.deleteIcon.render() + '</div>';
					return html;
	}*/


	onDataUpdated(action)
	{
		if (this.usedIcon && this.data)
			this.usedIcon.toggle( (this.data.number > 0) );

		if (action.type == "update")
		{
			if (this.data.deleted)
			{
				this.hide();
				return;
			}
			
			for(let i = 0; i < action.properties.length; i++)
			{
				if ("width,height,thumb,id".indexOf(action.properties[i]) == -1)
					continue;

				if (action.properties[i] == "thumb")
				{
					this.image.src = action.data[action.properties[i]];	
				}
				else
				if (action.properties[i] == "id")
				{
					this.id = action.data[action.properties[i]];
					this.image.attr("data-id", this.id);
				}
				else
				{
					this.image.attr("data-" + action.properties[i], action.data[action.properties[i]] );
				}	
			}
		}		
	}

	onDataEvent(event)
	{
		switch(event.type)
		{
			case "upload-file-progress" : 
				if (this.data.isHeic)
				{
					if (this.progress)
						this.progress.width( this.data.progress + "%");

					if (this.waiting)
						this.waiting.destroy();
				}
				break;

			case "media-file-uploaded" : 
				if (this.data.isHeic)
				{
					this.image.removeClass("uploading");
					this.image.addClass("draggable");
					this.progress.destroy();
					this.toolTip = "";
				}
				break;

			default :
				break;
		}
	}


	onMouseOver()
	{
		this.deleteIcon.show();
		//this.css(this.deleteIcon, {"opacity" : 1 });
	}

	onMouseOut()
	{
		this.deleteIcon.hide();
		//this.css(this.deleteIcon, {"opacity" : 0 });
	}

	onRemove(e)
	{
		e.preventDefault();
		if (typeof e.stopPropagation == "function")
			e.stopPropagation();

		this.data.delete();
	}
});